/**
 * Formats duration in minutes to HH:mm format
 * @param minutes - Duration in minutes
 * @returns Formatted duration string (e.g., "2:00" for 120 minutes, "0:30" for 30 minutes)
 */
export const formatDuration = (minutes: number | null | undefined): string => {
  if (!minutes || minutes === 0) {
    return '0:00';
  }

  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;

  return `${hours}:${mins.toString().padStart(2, '0')}`;
};
